import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Link } from 'react-router-dom'
import { Element } from '../../../common/html/element'
import { Icon } from '../../../common/html/icon'
import { Panel } from '../../../common/panel'
import { keyBy } from '../../../helpers/common'
import { formatVal } from '../../../helpers/value'
import { COMPONENTS } from '../../../routers/constants'
import classes from '../index.module.scss'
import { Table } from './../../../common/table/index'
import { TextEllipsisStaticLine } from './../../../common/textEllipsis/TextEllipsisStaticLine'
import { TABLE_COL } from './constant'

export const Portfolios = ({ data }) => {
  const locale = useSelector((state) => state.i18n.locale)
  const ids = data.map((item) => item.portfolioId)
  const dataById = keyBy(data, 'portfolioId')

  const getSchema = () => {
    return Object.keys(TABLE_COL).map((key) => {
      const title = `alertDetail.${key}`
      const colId = TABLE_COL[key]
      const thStyle = {
        justifyContent: [TABLE_COL.PORTFOLIO_TRIGGER].includes(colId)
          ? 'center'
          : '',
      }
      const tdStyle = {
        width:
          colId === TABLE_COL.STT
            ? 40
            : colId === TABLE_COL.PORTFOLIO_TRIGGER
            ? '20%'
            : '40%',
      }

      return {
        colId,
        title,
        isI18n: true,
        thStyle,
        tdStyle,
        render: (_, { rowId, rowIndex }) => {
          switch (colId) {
            case TABLE_COL.STT:
              return rowIndex + 1
            case TABLE_COL.PORTFOLIO_NAME:
              const isRedirect = dataById[rowId].isRedirectLink
              const Wrapper = isRedirect ? Link : Element
              return (
                <Element
                  className="wFitContent"
                  style={{
                    color: isRedirect ? '#2C73E8' : 'inherit',
                    cursor: isRedirect ? 'pointer' : 'default',
                  }}
                >
                  <Wrapper
                    to={`${COMPONENTS.library.components.savedPortfolios.components.detailsPortfolio.route}?id=${rowId}`}
                    target="_blank"
                  >
                    <TextEllipsisStaticLine
                      text={dataById[rowId].portfolioName}
                      isI18n={false}
                      tooltipMaxWidthByContent
                      lineClamp={1}
                    />
                  </Wrapper>
                </Element>
              )
            case TABLE_COL.PROFILE_NAME:
              const isRedirectProfile = dataById[rowId].profileAlertId
              const WrapperProfile = isRedirectProfile ? Link : Element
              return (
                <Element
                  className="cursorPointer wFitContent"
                  style={{
                    color: isRedirectProfile ? '#2C73E8' : 'inherit',
                    cursor: isRedirectProfile ? 'pointer' : 'default',
                  }}
                >
                  <WrapperProfile
                    to={`/alerts/settings?profileId=${dataById[rowId].profileAlertId}`}
                    target="_blank"
                  >
                    <TextEllipsisStaticLine
                      text={dataById[rowId].profileAlertsName}
                      isI18n={false}
                      tooltipMaxWidthByContent
                      lineClamp={1}
                    />
                  </WrapperProfile>
                </Element>
              )
            case TABLE_COL.PORTFOLIO_TRIGGER:
              return dataById[rowId].isPortfolioTrigger ? (
                <Element className="textCenter">
                  <Icon
                    className="icon-tick-circle-fill"
                    style={{ fontSize: 12, color: '#3DA967' }}
                  />
                </Element>
              ) : (
                ''
              )
            default:
              return ''
          }
        },
      }
    })
  }

  return (
    <Panel label="alertDetail.PORTFOLIOS" isI18n>
      <Element
        className={classes.note}
        style={{ color: '#3A414B', borderBottomColor: '#B5CEF8' }}
      >
        <Element className="mlAuto">
          <Translate value="alertDetail.TOTAL_PORTFOLIOS" />
          :&nbsp;
          {formatVal(data.length, locale, false, 0)}
        </Element>
      </Element>

      <Table
        ids={ids}
        schema={getSchema()}
        isNoDataWithHead
        isCenterNoData={false}
        noDataText="alerts.NO_ALERT_TO_DISPLAY"
        autoHeightMax={250}
      />
    </Panel>
  )
}
